import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss'],
    standalone: false
})
export class ProductComponent implements OnInit {
  background: ThemePalette = undefined;
  productId: any;
  productName: any;
  userType: any;

  selectedTabIndex = 0;
  
  get tabRoutes(): string[] {
    const routes = [
      'general',
      'training-materials',
      'marketing-materials',
      'competitors',
      'references',
      'value-proposal'
    ];

    if (this.isManufacturer()) {
      routes.push('subscriptions');
    }

    return routes;
  }

  constructor(
    public utils: UtilsService, 
    private route: ActivatedRoute, 
    private authService: AuthService,
    private router: Router
  ) {
    this.route.params
    .subscribe(
      (params: Params) => {
        this.productId = params.id;
        this.productName = params.name;
      });
    this.userType = this.authService.getUserData().type;
  }

  ngOnInit(): void {
    this.utils.setTitle('Products');
    this.userType = this.authService.getUserData().type;

    const path = this.route.firstChild?.snapshot.url[0]?.path;
    this.selectedTabIndex = this.tabRoutes.indexOf(path!) >= 0 ? this.tabRoutes.indexOf(path!) : 0;

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        const newPath = this.route.firstChild?.snapshot.url[0]?.path;
        this.selectedTabIndex = this.tabRoutes.indexOf(newPath!) >= 0 ? this.tabRoutes.indexOf(newPath!) : 0;
      });
  }


  onTabChange(index: number): void {
    const tabPath = this.tabRoutes[index];
    const queryParams = this.route.snapshot.queryParams;

    // If it's general, remove query params
    if (tabPath === 'general') {
      this.router.navigate([tabPath], {
        relativeTo: this.route,
        queryParams: {}
      });
    } else {
      this.router.navigate([tabPath], {
        relativeTo: this.route,
        queryParams
      });
    }
  }

  isManufacturer(): boolean {
    return (
      this.userType === this.utils.userTypes.Manufacturer ||
      this.userType === this.utils.userTypes.ManufacturerChild
    );
  }
}
